import React from 'react';
import ReleaseCard from './ReleaseCard';

export default function ReleaseV110({ createClickableListItem, createThumbnail }) {
  return (
    <ReleaseCard version="v1.1.0" date="31st January 2025" title="Refinements and Enhancements">
      <p className="text-gray-300 mb-4">We couldn't believe how well version 1 was received! This release focuses on performance improvements and player experience.</p>
      <ul className="text-gray-400 space-y-2 mb-4">
        <li>• Minimised websocket traffic</li>
        {createClickableListItem('Now cater for game breaks', '/v1.1.0/break.png')}
        <li>• Fixed bug with paused game</li>
        <li>• Increased GPS game finder from 50 miles to 200 miles</li>
      </ul>
      <div className="mb-4">
        <p className="text-gray-300 mb-2 text-sm">This releases screenshots:</p>
        <div className="flex flex-wrap gap-4">
          {createThumbnail('/v1.1.0/break.png', 'Game breaks feature preview')}
        </div>
      </div>
      <p className="text-purple-400 font-medium">If you have an idea, send us a message!</p>
    </ReleaseCard>
  );
}
